module.exports = __webpack_public_path__ + "img/gift3-04-c1.49dd5e7e.png";